'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_InvalideEvent(errorMessage) {
  this.rM = null;
  this.rM = errorMessage;
}
export { $c_Ldev_cheleb_scalamigen_InvalideEvent as $c_Ldev_cheleb_scalamigen_InvalideEvent };
$p = $c_Ldev_cheleb_scalamigen_InvalideEvent.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_InvalideEvent;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_InvalideEvent() {
}
export { $h_Ldev_cheleb_scalamigen_InvalideEvent as $h_Ldev_cheleb_scalamigen_InvalideEvent };
$h_Ldev_cheleb_scalamigen_InvalideEvent.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-1569555396), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Ldev_cheleb_scalamigen_InvalideEvent) && (this.rM === x$0.rM)));
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 1;
});
$p.o = (function() {
  return "InvalideEvent";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.rM;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Ldev_cheleb_scalamigen_InvalideEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.d4)));
}
export { $isArrayOf_Ldev_cheleb_scalamigen_InvalideEvent as $isArrayOf_Ldev_cheleb_scalamigen_InvalideEvent };
var $d_Ldev_cheleb_scalamigen_InvalideEvent = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_InvalideEvent, "dev.cheleb.scalamigen.InvalideEvent", ({
  d4: 1,
  bN: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Ldev_cheleb_scalamigen_InvalideEvent as $d_Ldev_cheleb_scalamigen_InvalideEvent };
